module.exports = __webpack_public_path__ + "static/img/home_video_poster.28ef458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/home_video_poster.jpg
// module id = EwJ9
// module chunks = 1